const TermsAndConditions = () => {
  return (
    <div className="max-w-5xl mx-auto p-6 text-gray-800">
      <h1 className="sm:text-2xl text-3xl font-bold mb-6">
        Terms and Conditions
      </h1>

      <p className="mb-4">Effective Date: 20/04/2025</p>
      <p className="mb-4">Website: www.thezaik.com</p>

      <p className="mb-4">
        Welcome to thezaik.com! These Terms and Conditions ("Terms") govern your
        use of our website and the services provided by Zaik. By accessing or
        using the site, you agree to be bound by these Terms. If you do not
        agree, please do not use our services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Overview</h2>
      <p className="mb-4">
        thezaik.com is an e-commerce platform that offers customized outfits for
        both bulk orders and individual personal orders. Our services are
        available across India and accessible to users of all age groups,
        although use by minors under the age of 13 is not promoted or
        encouraged.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>
      <p className="mb-4">By using this website, you confirm that:</p>
      <ul className="list-disc list-inside mb-4">
        <li>You are at least 13 years old</li>
        <li>You have the legal capacity to enter into a binding contract</li>
        <li>You are using the site for lawful purposes</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Products and Services
      </h2>
      <p className="mb-4">Thezaik specializes in:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Custom-tailored clothing for individuals</li>
        <li>
          Customized uniforms and outfits for businesses, events, and groups
        </li>
      </ul>
      <p className="mb-4">
        All product descriptions and pricing are subject to change without
        notice. We strive for accuracy, but we do not guarantee that all product
        descriptions or content on the website are error-free.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Orders and Payments
      </h2>
      <h3 className="text-lg font-semibold mt-4 mb-2">4.1 Order Placement</h3>
      <p className="mb-4">
        Orders can be placed through our website at any time. All orders are
        subject to availability and acceptance.
      </p>
      <h3 className="text-lg font-semibold mt-4 mb-2">4.2 Payment Methods</h3>
      <p className="mb-4">We accept the following payment methods:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Online payments via our secure payment gateway</li>
        <li>Cash on Delivery (COD)</li>
      </ul>
      <p className="mb-4">
        Thezaik reserves the right to refuse any order placed on the website if
        fraudulent or suspicious activity is suspected.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Cancellations and Modifications
      </h2>
      <p className="mb-4">
        You may cancel your order anytime before or on the day of delivery. To
        request a cancellation, please contact our customer support team at
        zaikcare@gmail.com with your order details.
      </p>
      <p className="mb-4">
        We reserve the right to cancel or refuse orders at our discretion,
        particularly in cases of incorrect pricing, stock unavailability, or
        suspicious behavior.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Intellectual Property
      </h2>
      <p className="mb-4">
        All content on this site—including logos, images, text, graphics, and
        software—is the property of thezaik.com and is protected under
        applicable intellectual property laws. Unauthorized use or reproduction
        of any content is strictly prohibited.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. User Conduct</h2>
      <p className="mb-4">You agree not to:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Use the website for unlawful purposes</li>
        <li>Transmit harmful or disruptive code (e.g., malware or viruses)</li>
        <li>
          Violate the security of the website or attempt unauthorized access
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Disclaimer of Liability
      </h2>
      <p className="mb-4">Thezaik is not responsible for:</p>
      <ul className="list-disc list-inside mb-4">
        <li>
          Any damage, injury, or loss resulting from the misuse of our products
        </li>
        <li>
          Delay or failure in performance due to circumstances beyond our
          control (e.g., natural disasters, courier delays)
        </li>
        <li>Third-party services linked through our website</li>
      </ul>
      <p className="mb-4">
        All products are provided "as-is" without warranties of any kind,
        express or implied.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        9. Limitation of Liability
      </h2>
      <p className="mb-4">
        To the fullest extent permitted by law, thezaik.com and its affiliates
        shall not be liable for any indirect, incidental, or consequential
        damages arising from the use or inability to use our website or
        products.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Governing Law</h2>
      <p className="mb-4">
        These Terms and any disputes related to the use of the website shall be
        governed and interpreted in accordance with the laws of India. Any legal
        proceedings shall be subject to the exclusive jurisdiction of the courts
        located in [Insert City], India.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Changes to Terms</h2>
      <p className="mb-4">
        Thezaik reserves the right to update or modify these Terms at any time.
        We will notify users of any changes by updating the "Effective Date" at
        the top of this page. Continued use of the website following any changes
        indicates your acceptance of the revised Terms.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">12. Contact Us</h2>
      <p className="mb-4">
        For questions, feedback, or legal concerns, please contact us at:
        <br />
        📧 Email: zaikcare@gmail.com
        <br />
        🌐 Website: www.thezaik.com
      </p>
    </div>
  );
};

export default TermsAndConditions;
